// The chooser's option tiles and the cart's add-on cards share one selection look so a customer
// reads every choice the same way. Size, radius and padding stay with each tile, since they differ
// per tile.

// A 2 px black frame on the cream fill. The inset ring draws the second pixel inside the 1 px
// border, so a tile neither grows nor rewraps its content when it becomes selected.
export const SELECTED_OPTION_TILE_CLASSES =
  'border border-neutral-100 bg-primary-10 ring-1 ring-inset ring-neutral-100';

// A tile nested inside another option, like the small tiles of a chooser set row, sits on that
// option's cream fill once the option is selected. A cream tile would vanish there, so the
// selected nested tile is white.
export const NESTED_SELECTED_OPTION_TILE_CLASSES =
  'border border-neutral-100 bg-white ring-1 ring-inset ring-neutral-100';

// neutral-50 is the lightest grey whose edge still reaches 3:1 on white (WCAG 1.4.11), so an
// unselected tile stays visible as a control. It has no fill, so a nested tile shows the fill of
// the option around it.
export const UNSELECTED_OPTION_TILE_CLASSES = 'border border-neutral-50 hover:border-neutral-70';

export interface OptionTileStateOptions {
  isNested?: boolean;
}

export function getOptionTileStateClasses(
  isSelected: boolean,
  { isNested = false }: Readonly<OptionTileStateOptions> = {},
): string {
  if (!isSelected) {
    return UNSELECTED_OPTION_TILE_CLASSES;
  }

  return isNested ? NESTED_SELECTED_OPTION_TILE_CLASSES : SELECTED_OPTION_TILE_CLASSES;
}
